import { render, staticRenderFns } from "./OfficeTool.vue?vue&type=template&id=2e9cfe51&scoped=true&"
import script from "./OfficeTool.vue?vue&type=script&lang=js&"
export * from "./OfficeTool.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTool.vue?vue&type=style&index=0&id=2e9cfe51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9cfe51",
  null
  
)

export default component.exports